<ng-template [ngIf]="attiForm">
<div>
	<div class="col-sm-12 coldx">
		<h4 *ngIf="isGestioneDocumenti" style="margin-left: 0px">{{title}}</h4>
    <h4 *ngIf="!isGestioneDocumenti">{{title}}</h4>
		<form [formGroup]="attiForm" (ngSubmit)="update();">
			<div class="row">
				<div *ngIf="alert" class="alert alert-danger" role="alert">
					La tipologia di atto non è più disponibile, selezionare la nuova
				</div>
				<div comboModInput class="col-sm-8"
					[autocomplete]="true"
					formControlName="tipoAtto"
					[labelInput]="'Tipo atto'"
					[mandatory]="true"
					[optionsCombo]="tipiAttoOptions"
					[objectReference]="request.tipoAtto"
					(onReturn)="request.tipoAtto = $event; attiForm.controls['tipoAtto'].setValue($event); onTipoAttoChanged($event);">
				</div>
				<div class="col-sm-4">
					<p>
						<label>Provenienza</label><span class="mandatory">*</span>
						<select class="form-control provenienza-select-class"
							formControlName="provenienza"
							[compareWith]="compareById"
							(change)="request.provenienza = attiForm.controls['provenienza'].value">
							<option [ngValue]="null">Scegli Provenienza</option>
							<option *ngFor="let option of tipiProvenienzaOptions" [ngValue]="option">{{option.label}}</option>
						</select>
					</p>
				</div>

				<div datePickerInput class="col-sm-4" [labelInput]="'Data Notifica'"
				   formControlName="dataNotifica" [(ngModel)]="request.dataNotifica"
				   [mandatory]="true"></div>

				<div datePickerInput class="col-sm-4" [labelInput]="'Data Deposito'"
					formControlName="dataDeposito" [(ngModel)]="request.dataDeposito"></div>

				<div checkBoxRadio class="col-sm-4"
					[labelInput]="'Titolo esecutivo'"
					[idInput]="inserimento ? 'titoloEsecutivo-ins' : 'titoloEsecutivo-mod'"
					formControlName="titoloEsecutivo"
					[control]="attiForm.controls['titoloEsecutivo']"
					[objectReference]="request.titoloEsecutivo"
					(onReturn)="request.titoloEsecutivo = $event;"
					(change)="request.dataApposizioneFormulaEsecutiva=undefined;">
				</div>
			</div>

			<div class="row">
				<div datePickerInput class="col-sm-4"
					[labelInput]="'Data apposizione formula esecutiva'"
					[control]="attiForm.controls['dataApposizioneFormulaEsecutiva']"
					formControlName="dataApposizioneFormulaEsecutiva"
					[mandatory]="request.titoloEsecutivo"
					[submitPending]="!request.titoloEsecutivo"
					[(ngModel)]="request.dataApposizioneFormulaEsecutiva"></div>
				<div datePickerInput class="col-sm-4"
					[labelInput]="'Data pubblicazione'"
					[control]="attiForm.controls['dataPubblicazione']"
					formControlName="dataPubblicazione"
					[(ngModel)]="request.dataPubblicazione">
				</div>
			</div>

			<div class="row">
				<div textAreaInput class="form-group col-xs-12 col-sm-12"
					[labelInput]="'Note'" formControlName="note"
					[(ngModel)]="request.note"></div>
			</div>

			<!-- Bottoni modifica: restano dentro il form -->
			<div *ngIf="!inserimento" class="row" [ngClass]="{'pb-10': isGestioneDocumenti}">
				<p *ngIf="isGestioneDocumenti && !inserimento" class="col-sm-3 col-xs-6">
					<button type="button" class="btn btn-outline-secondary btn-block" (click)="onAnnullaModifiche();">Annulla modifiche</button>
				</p>
				<p *ngIf="!isGestioneDocumenti" class="col-sm-3 col-xs-6">
					<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
				</p>
				<p submitButton *ngIf="isGestioneDocumenti && !inserimento" class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Modifica atto'"
					[disabled]="!attiForm.valid || (request.titoloEsecutivo && !request.dataApposizioneFormulaEsecutiva)">
				</p>
				<p submitButton *ngIf="!isGestioneDocumenti" class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Inserisci e salva'"
					[disabled]="!attiForm.valid || (request.titoloEsecutivo && !request.dataApposizioneFormulaEsecutiva)"></p>
			</div>
		</form>

    <!-- SEZIONE DOCUMENTI - visibile solo in inserimento -->
    <ng-container *ngIf="inserimento && aggiungiDocumentoForm">
      <hr>
      <h5>Documenti allegati</h5>
      <div [formGroup]="aggiungiDocumentoForm">
        <div class="row">
          <div ng-select-combo class="col-sm-6" formControlName="tipoVisibilitaDocumento" [label]="'Visibilità documento'"
               [required]="true" [options]="tipiVisibilitaDocumento" [optionSel]="docFormRequest.tipoVisibilitaDocumento"
               (onChangeSel)="docFormRequest.tipoVisibilitaDocumento = $event; aggiungiDocumentoForm.controls['tipoVisibilitaDocumento'].setValue($event);">
          </div>
        </div>
        <!-- <div class="row">
          <div textAreaInput class="col-sm-12" [labelInput]="'Note documento'" formControlName="note"
               [(ngModel)]="docFormRequest.note"></div>
        </div> -->
        <div class="row">
          <div class="col-sm-10">
            <div class="alert alert-danger col-sm-10 d-flex align-items-center" *ngIf="docLoading" role="alert"
                 aria-live="assertive" aria-atomic="true">
              <span>Uno o più file sono in caricamento, attendere...</span>
              <div class="spinner-border text-light ms-2" role="status" aria-label="Caricamento in corso"
                   style="width: 1.5rem; height: 1.5rem; margin-left: 8px">
                <span class="sr-only">Caricamento...</span>
              </div>
            </div>
            <ul style="list-style: none; padding: 0;" *ngIf="fileUploadList?.length">
              <li *ngFor="let item of fileUploadList; let index = index">
                <app-document-uploaded
                  [indexFile]="index"
                  [tipiDocumentoOptions]="tipiDocumento"
                  (onReturn)="onDocReturn($event)"
                  (onExtract)="onExtractArchive($event)"
                  (onRemoveFile)="deleteDocFile($event.index)"
                  [file]="item"
                  [protocol]="false">
                </app-document-uploaded>
              </li>
            </ul>
          </div>
          <div class="col-sm-2" style="margin-top: 20px">
            <app-upload-tool [standard]="true" [disabled]="docLoading" (onChange)="onSearchChange($event)"></app-upload-tool>
          </div>
        </div>
        <!-- <div class="row">
          <p class="mandatory col-sm-12">
            <em>* Campi obbligatori se si allega almeno un documento</em>
          </p>
        </div> -->
      </div>
    </ng-container>

    <div class="row">
      <p class="mandatory col-sm-12">
        <em>* Campi obbligatori</em>
      </p>
    </div>
    <!-- Bottoni inserimento: in fondo dopo la sezione documenti -->
    <div *ngIf="inserimento" class="row" [ngClass]="{'pb-10': isGestioneDocumenti}">
      <p *ngIf="isGestioneDocumenti && inserimento" class="col-sm-3 col-xs-6">
        <button type="button" class="btn btn-outline-secondary btn-block" (click)="onPulisciCampi();">Reset</button>
      </p>
      <p *ngIf="!isGestioneDocumenti" class="col-sm-3 col-xs-6">
        <button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm(); resetDocForm();">Reset</button>
      </p>
      <p submitButton *ngIf="isGestioneDocumenti && inserimento" class="col-sm-3 col-xs-6 col-sm-offset-6"
        [labelButton]="'Aggiungi atto'"
        (click)="update()"
        [disabled]="!attiForm.valid || (request.titoloEsecutivo && !request.dataApposizioneFormulaEsecutiva) || !canDocSave">
      </p>
      <p submitButton *ngIf="!isGestioneDocumenti" class="col-sm-3 col-xs-6 col-sm-offset-6"
        [labelButton]="'Inserisci e salva'"
        (click)="update()"
        [disabled]="!attiForm.valid || (request.titoloEsecutivo && !request.dataApposizioneFormulaEsecutiva) || !canDocSave">
      </p>
    </div>

	</div>
</div>
</ng-template>
